import { render, staticRenderFns } from "./GStudentRecord.vue?vue&type=template&id=3064693e&scoped=true&"
import script from "./GStudentRecord.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecord.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecord.vue?vue&type=style&index=0&id=3064693e&lang=scss&scoped=true&"
import style1 from "./GStudentRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064693e",
  null
  
)

export default component.exports